// H187 (RN15-RN17, S68): the single formatter of the workflow copy origin text. Every surface (orders table,
// Operations block, FO detail Workflow field, workflow editor header) imports it; none builds the text itself.
//
// D-J2 (option A): `workflowLabelOf` stays where it lives (`configuration/orders/detail/workflowAssignment.js`)
// and is imported from there, so the version convention (V1 is not written, `- V2` is) has one rule.
import { workflowLabelOf } from '../../configuration/orders/detail/workflowAssignment'

const SEPARATOR = ' · '

const isFilled = (value) => value !== null && value !== undefined && value !== ''

/**
 * "Is a copy" <=> the workflow carries an `origin` object (contrato-sun warning 2). It never looks at
 * `linkedToFabricationOrder`: the listing publishes it `false` even for copies.
 */
export const hasWorkflowOrigin = (origin) => !!origin && typeof origin.known === 'boolean'

/** A copy whose origin is registered: `known:true` with a filled code and version (same rule as the text below). */
export const isWorkflowOriginKnown = (origin) => hasWorkflowOrigin(origin) && origin.known && isFilled(origin.code) && isFilled(origin.version)

/**
 * '' | 'Based on <label>' | 'Unknown origin' (already translated). `known:true` with an empty code or version
 * is read tolerantly as unknown.
 */
export const workflowOriginTextOf = (origin, t_) => {
  if (!hasWorkflowOrigin(origin)) return ''
  if (!isWorkflowOriginKnown(origin)) return t_('Unknown origin')
  return t_('Based on {{workflow}}', { workflow: workflowLabelOf({ code: origin.code, version: origin.version }) })
}

/**
 * `{ code, originText, text }` of a workflow DTO. `text` is the code, or `<code> · <originText>`. Tolerant input:
 * undefined/null/{} give empty strings. No fallback to `workflow.name` (D-J1): it is the master's name.
 */
export const describeWorkflow = (workflow, t_) => {
  const code = isFilled(workflow?.code) ? String(workflow.code) : ''
  const originText = workflowOriginTextOf(workflow?.origin, t_)
  return { code, originText, text: [code, originText].filter(Boolean).join(SEPARATOR) }
}
